var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"ow-oral-component-image",attrs:{"src":_vm.src,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }